import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon } from '@ionic/angular';

import { UserAvatarComponent } from '@ninety/mobile/platform/components';
import { UserNamePipe } from '@ninety/mobile/platform/services';

import { DiscussionListItem, DiscussionModel } from '../../models/discussion.models';
import { UserInitialsPipe } from '../../pipes/user-initials.pipe';

@Component({
  selector: 'nty-discussion-form-participants',
  imports: [IonIcon, UserAvatarComponent, UserInitialsPipe, UserNamePipe],
  template: `
    <div class="participant-container">
      <nty-user-avatar
        size="24px"
        fontSize="10px"
        [userInitials]="discussion.manager | userName | userInitials"
        [avatarUrl]="managerAvatarUrl" />

      <div class="discussion-participant-name terra-body" [class.current-participant]="highlight === 'manager'">
        {{ discussion.manager | userName }}
      </div>
    </div>

    <ion-icon name="swap-horizontal" size="large" />

    <div class="participant-container">
      <nty-user-avatar
        size="24px"
        fontSize="10px"
        [userInitials]="discussion.managee | userName | userInitials"
        [avatarUrl]="manageeAvatarUrl" />

      <div class="discussion-participant-name terra-body" [class.current-participant]="highlight === 'managee'">
        {{ discussion.managee | userName }}
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @use 'terra';

      :host,
      .participant-container {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .participant-container {
        gap: 6px;
      }

      .discussion-participant-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 90%;
        flex-grow: 1;
        color: terra.color(text);
      }

      ion-icon {
        width: 15px;
        color: terra.color(neutral-mid, 400);
      }

      .current-participant {
        font-weight: bold;
      }
    `,
  ],
})
export class DiscussionFormParticipantsComponent {
  @Input({ required: true }) discussion!: DiscussionModel | DiscussionListItem;
  @Input() highlight: 'manager' | 'managee' | 'none' = 'none';

  get managerAvatarUrl() {
    return this.discussion.manager?.metadata?.picture?.url ?? '';
  }

  get manageeAvatarUrl() {
    return this.discussion.managee?.metadata?.picture?.url ?? '';
  }
}
